export const informationSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': 'https://www.datauniverse.co.kr/#website',
      url: 'https://www.datauniverse.co.kr',
      name: '㈜데이터유니버스',
    },
    {
      '@type': 'WebPage',
      '@id': 'https://www.datauniverse.co.kr/information/#webpage',
      url: 'https://www.datauniverse.co.kr/information',
      name: '회사 정보 | ㈜데이터유니버스',
      description: '㈜데이터유니버스의 서비스, 특허, 인증내역, 연혁, CI를 확인해보세요.',
      isPartOf: {
        '@id': 'https://www.datauniverse.co.kr/#website',
      },
    },
    {
      '@type': 'Organization',
      '@id': 'https://www.datauniverse.co.kr/#organization',
      name: '㈜데이터유니버스',
      legalName: '㈜데이터유니버스',
      url: 'https://www.datauniverse.co.kr',
      logo: 'https://img.datau.co.kr/dulogo.png',
      sameAs: [
        'https://www.youtube.com/@%EB%8D%B0%EC%9D%B4%ED%84%B0%EC%9C%A0%EB%8B%88%EB%B2%84%EC%8A%A4',
      ],
      contactPoint: [
        {
          '@type': 'ContactPoint',
          email: 'contact@datau.co.kr',
          contactType: 'customer service',
        },
        {
          '@type': 'ContactPoint',
          email: 'biz@datau.co.kr',
          contactType: 'sales',
        },
        {
          '@type': 'ContactPoint',
          email: 'recruit@datau.co.kr',
          contactType: 'recruitment',
        },
      ],
      description:
        "㈜데이터유니버스는 2018년 설립 이후 더 나은 세상을 위해 금융사기, 개인정보유출 등 사회 문제를 정보통신기술(ICT)로 해결해 나아가고 있습니다. '스마트피싱보호', '휴대폰분실보호', '휴대폰가족보호', '휴대폰쿠폰지갑', '이벤트유', '오토콜' 서비스를 제공하며, 2023년부터는 사회공헌 활동에도 적극적으로 참여하고 있습니다.",
      award: [
        {
          '@type': 'Award',
          name: '기술평가 우수기업 인증 (T-3)',
        },
        {
          '@type': 'Award',
          name: '기업부설연구소 인정',
        },
        {
          '@type': 'Award',
          name: '기술혁신형 중소기업 (이노비즈) 확인',
        },
        {
          '@type': 'Award',
          name: '서울형 강소기업 확인',
        },
      ],
      patent: [
        {
          '@type': 'CreativeWork',
          name: '분실 휴대폰 회수 지원 서비스 방법',
          identifier: '10-2505243',
        },
        {
          '@type': 'CreativeWork',
          name: '스마트폰을 통한 보호 서비스 제공 방법',
          identifier: '10-2473351',
        },
        {
          '@type': 'CreativeWork',
          name: '메신저 피싱 예방을 위한 사용자 확인 방법',
          identifier: '10-2156905',
        },
        {
          '@type': 'CreativeWork',
          name: '금융 사기 예방 방법 II',
          identifier: '10-2128601',
        },
        {
          '@type': 'CreativeWork',
          name: '금융 사기 예방 방법 I',
          identifier: '10-2001157',
        },
        {
          '@type': 'CreativeWork',
          name: '이동통신 단말을 이용한 개인정보 처리 방법',
          identifier: '10-1636281',
        },
        {
          '@type': 'CreativeWork',
          name: '스마트 단말기의 실명인증 시스템',
          identifier: '10-1381388',
        },
        {
          '@type': 'CreativeWork',
          name: '휴대폰의 보이스피싱 방지 서비스 방법',
          identifier: '10-1098532',
        },
        {
          '@type': 'CreativeWork',
          name: '휴대단말기를 이용한 OTP 방식의 사용자인증 시스템 및 방법',
          identifier: '10-1028882',
        },
        {
          '@type': 'CreativeWork',
          name: '휴대폰을 이용한 사용자 인증 방법',
          identifier: '10-0949055',
        },
      ],
    },
  ],
}
